import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="favorites-filter-toggle"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.form = document.getElementById('auction-filters-form')
    this.formInput = this.form.querySelector('[name="favorites_only"]')
  }

  toggleAndSubmit() {
    let newValue = this.inputTarget.checked
    this.formInput.value = (newValue === true).toString()
    this.submit()
  }

  submit() {
    this.form.requestSubmit();
  }
}
